import {
  CREATETEAM,
  GETTEAM,
  DELETETEAM,
  UPDATETEAM,
} from "../actions/types";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case GETTEAM:
      return {
        ...state,
        teamList: action.payload.data,
      };
    case UPDATETEAM:
      return {
        ...state,
        teamUpdateStatus: action.payload.success,
      };

case DELETETEAM:
  return {
    ...state,
    teamList: state.teamList.filter((item) => item.id !== action.teamId), 
    teamDeleteStatus: action.payload.success,
  };
    default:
      return state;
  }
}
